module.exports = __webpack_public_path__ + "static/img/zxsbwt.d646e04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/zxsbwt.png
// module id = 7xRl
// module chunks = 0